import React from "react";

function CtypeCheck({ value, onChange }) {
  return (
    <aside className="package-widget widget-tour-categoris mt-30">
      <div className="widget-title"><h4>Onsite or online?</h4></div>
      <div className="widget-body">
        <select className="form-select" value={value} onChange={(e) => onChange(e.target.value)}>
          <option value="all">All workshops</option>
          <option value="onsite">Onsite workshops</option>
          <option value="online">Online workshops</option>
        </select>
      </div>
    </aside>
  );
}
export default CtypeCheck;
